<template>
<div class="chapter">
<div class="inner_page">
<a id="page_i"></a>
<p class="half">B<span class="small-caps">ATTLE OF</span> L<span class="small-caps">EYTE</span> G<span class="small-caps">ULF</span></p>
<p class="half1">T<span class="small-caps">HE</span> L<span class="small-caps">ARGEST</span> S<span class="small-caps">EA</span> B<span class="small-caps">ATTLE OF THE</span> S<span class="small-caps">ECOND</span> W<span class="small-caps">ORLD</span> W<span class="small-caps">AR</span><a id="page_ii"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Halftitle.vue?0c8f7102